export class OrderActivityTransformer {
  static transform(obj) {
    let orderOperation = {};
    orderOperation.id = obj.id;
    orderOperation.orderId = obj.attributes.order_id;
    orderOperation.orderOperationId = obj.attributes.order_operation_id;
    orderOperation.description = obj.attributes.description;
    orderOperation.createdBy = obj.attributes.created_by;
    return orderOperation;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/orderActivities/orderActivity.transformer.js